import React, { useEffect, useState, useRef } from 'react';
import {
  Table,
  Button,
  Space,
  Divider,
  Switch,
  Popconfirm,
  Select,
} from 'antd';
import './Catalog.css';
import './CatalogModern.css';
import { useSelector } from 'react-redux';
import { PlusOutlined } from '@ant-design/icons';
import { arrayUnion, doc, onSnapshot } from 'firebase/firestore';
import { db } from '../database/firebase';
import { Modal } from 'semantic-ui-react';
import { Accordion, Icon, Popup, Button as BS } from 'semantic-ui-react';

import ScutireDisplay from './ScutireDisplay';
import Docxtemplater from 'docxtemplater';
import { motiveazaAbsente } from '../utils/absente';
import { Alert } from 'antd';
import PizZip from 'pizzip';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import JSZip from 'jszip';
// Templates are now loaded from Redux settings instead of direct import
import CatalogPrint from './CatalogPrint';
import {
  useWindowSize,
  useWindowWidth,
  useWindowHeight,
} from '@react-hook/window-size';
import { getDataDoc } from '../database';
import { updateDocDatabase } from '../database';
import ModalAddGrade from './ModalAddGrade';
import ModalTabularGrade from './ModalTabularGrade';
import { Table as CatalogTabel } from 'semantic-ui-react';
import ModalViewGrade from './ModalViewGrade';
import { useReactToPrint } from 'react-to-print';
import { useNavigate } from 'react-router-dom';
import { openSuccesNotification } from '../Components/Notifications/succesNotification';
import {
  calculare_medii,
  calculeaza_medie_materie,
} from '../utils/calculare_medie';
import { exportExcel } from './excelexport';
import { openErrorNotification } from './Notifications/errorNotification';
import { renderClassName } from '../utils';
import AddElev from '../Pages/Admin/AddElev';
import CatalogElev from '../Pages/Elevi/CatalogElev';
import withErrorBoundary from './withErrorComponent';
import ExportMedii from './ExportMedii';

function Catalog({ classData, setClassData, mode = 'edit', permision }) {
  const [eleviData, setEleviData] = useState([]);
  const componentRef = useRef();

  const onlyWidth = useWindowWidth();
  const [open, setOpen] = useState(false);
  const [gradesElevi, setGradesElevi] = useState([]);
  const [elevId, setElevId] = useState();
  const [elevId2, setElevId2] = useState();
  const [audit, setAudit] = useState(false);
  const [aprins, setAprins] = useState(false);
  const [openAveritzare, setOpenAvertizare] = useState(false);
  const [teza, setTeza] = useState();
  const materiiRedux = useSelector((state) => state.materii);
  const [materieId, setMaterieId] = useState();
  const [nota, setNota] = useState();
  const [inchideMediiAutomat, setInchideMediiAutomat] = useState(false);
  const [allData, setAllData] = useState({});
  const profesori = useSelector((state) => state.profesori);
  const settings = useSelector((state) => state.settings);
  const clase = useSelector((state) => state.clase);
  const Limit = 40;
  const [deleted, setDeleted] = useState('');
  const [motivStergereMedie, setMotivStergereMedie] = useState('');
  const [notePrint, setNotePrint] = useState([]);
  const [author, setAuthor] = useState('');
  const navigate = useNavigate();
  const [comentariu, setComentariu] = useState();
  const [edit, setEdit] = useState(false);

  const [faraNote, setFaraNote] = useState(false);
  const [addElev, setAddElev] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [activeMaterii, setActiveMaterii] = useState([]);
  const windowSize = useRef(window.innerWidth);
  const [data, setData] = useState();
  const auditRef = useRef();
  const user = useSelector((state) => state.user);

  const [tip, setTip] = useState();
  const [entity, setEntity] = useState({});
  const [scutiri, setScutiri] = useState({});
  const [display, setDisplay] = useState(false);

  const [id, setId] = useState('');
  const auditRef2 = useRef();
  const [profileElevi, setProfileElevi] = useState({});
  const [sumar, setSumar] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [openTabular, setOpenTabular] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);
  const hasScrolledRef = useRef(false); // ca să facem scroll doar prima dată

  const banned = [
    'Teorie-solfegiu-dicteu',
    'Armonie',
    'Etnografie și folclor muzical',
    'Forme muzicale',
    'Muzică vocală tradițională românească',
    'Artă vocală interpretativă',
    'Corepetiție',
    'Instrument principal - Pian',
    'Instrument principal - Vioară',
    'Instrument principal - Chitară',
    'Instrument principal - Clarinet',
    'Instrument principal - Flaut',
    'Instrument principal - Contrabas',
    'Pian complementar',
    'Instrument la alegere - Vioară',
    'Instrument la alegere - Chitară',
    'Instrument la alegere - Clarinet',
    'Instrument la alegere - Flaut',
    'Instrument la alegere - Contrabas',
    'Instrument auxiliar - Vioară',
    'Instrument auxiliar - Chitară',
    'Instrument auxiliar - Clarinet',
    'Instrument auxiliar - Flaut',
    'Ansamblu coral/Ansamblu instrumental',
    'Acompaniament',
    'Ansamblu orchestral/Ansamblu instrumental/coral',
    'Ansamblu folcloric',
    'Muzică de cameră',
  ];

  const pref = [
    'Limba și literatura română',
    'Limba Engleză',
    'Limba Italiană',
    'Matematică',
    'Fizică',
    'Chimie',
    'Biologie',
    'Istorie',
    'Geografie',
    'Logică',
    'Religie',
    'Arte vizuale și abilități practice',
    'Educație fizică',
    'Teorie-solfegiu-dicteu',
    'Tehnologia informației și a comunicațiilor',
    'Etnografie și folclor muzical',
    'Muzică vocală tradițională românească',
    'Instrument la alegere - Vioară',
    'Instrument la alegere - Chitară',
    'Instrument la alegere - Clarinet',
    'Instrument la alegere - Flaut',
    'Instrument la alegere - Contrabas',
    'Corepetiție',
    'Ansamblu folcloric',
    'Istoria Muzicii',
    'Psihologie',
    'Educație Anteprenorială',
    'Economie',
    'Armonie',
    'Forme muzicale',
    'Muzică de cameră',
    'Consiliere și orientare / Purtare',
  ];
  const handlePrint = useReactToPrint({
    content: () => auditRef.current,
  });
  const handlePrint2 = useReactToPrint({
    content: () => auditRef2.current,
  });

  async function generateDocument(resume, templatePath) {
    try {
      const response = await fetch(templatePath);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.arrayBuffer();

      if (data.byteLength === 0) {
        throw new Error('Template data is empty!');
      }

      let zip;
      try {
        zip = new PizZip(data);
      } catch (error) {
        throw new Error('Error reading ZIP data: ' + error.message);
      }

      let templateDoc;
      try {
        templateDoc = new Docxtemplater(zip, {
          paragraphLoop: true,
          linebreaks: true,
        });
      } catch (error) {
        throw new Error('Error loading docxtemplater: ' + error.message);
      }

      templateDoc.render(resume);

      const base64 = templateDoc.getZip().generate({
        type: 'base64',
        mimeType:
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      });

      return base64;
    } catch (error) {
      console.error('Error generating document: ' + error.message);
      return null;
    }
  }

  const styleD = () => {
    if (onlyWidth < 700) return 'auto';
    if (onlyWidth < 1000) return 'auto auto ';
    if (onlyWidth < 1200) return 'auto auto auto ';
    return 'auto auto auto  ';
  };
  useEffect(() => {
    if (
      eleviData?.length > 0 &&
      (user.id === classData?.diriginte ||
        user.id === classData?.diriginte_step)
    )
      if (
        eleviData?.find(
          (e) =>
            !e.numarTelefon ||
            !e.domiciliu ||
            !e.mama ||
            !e.tata ||
            !e.numarMatricol
        ) &&
        !aprins
      ) {
        setAprins(true);
        setOpenAvertizare(true);
      }
  }, [eleviData]);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const id = hash.slice(1);
      let attempts = 0;
      const maxAttempts = 10;

      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        } else if (attempts < maxAttempts) {
          attempts++;
          setTimeout(tryScroll, 100); // mai încearcă în 100ms
        }
      };

      tryScroll();
    }
  }, []);
  const fetchData = async () => {
    let newArray = [];
    let scutiriElevi = {};
    let note = {};
    let NotePrint = [];

    const elevi = classData?.elevi || [];

    // --- Parallelize initial data fetching for all students ---
    const initialDataPromises = elevi.map(async (elev) => {
      const [docs, elevData] = await Promise.all([
        getDataDoc('eleviDocumente', elev.id),
        getDataDoc('elevi', elev.id),
      ]);
      return { elev, docs, elevData };
    });

    const initialResults = await Promise.all(initialDataPromises);

    const date = {}; // This will store elevData for each student
    initialResults.forEach(({ elev, docs, elevData }) => {
      date[elev.id] = elevData;
      scutiriElevi[elev.id] = docs?.docsElev.filter(
        (doc) => doc.tip === 'scutire' || doc.tip === 'bilet'
      );
    });

    // --- Parallelize fetching catalog notes for all students ---
    const catalogNotesPromises = elevi.map(async (elev) => {
      const notes = await getDataDoc('catalog', elev.id);
      return { elev, notes };
    });

    const catalogNotesResults = await Promise.all(catalogNotesPromises);

    catalogNotesResults.forEach(({ elev, notes }) => {
      let studentNotes;
      let studentAbsente;

      if (elev.mutat === true) {
        studentNotes = elev.gradesFrozen;
        studentAbsente = motiveazaAbsente(
          elev.gradesFrozen,
          elev?.docsFrozen?.docsElev
        );
      } else {
        studentNotes = notes?.note;
        studentAbsente = motiveazaAbsente(notes?.note, scutiriElevi[elev.id]);
      }

      note[elev.id] = {
        note: studentNotes,
        absente: studentAbsente,
      };

      newArray.push({
        ...elev,
        ...date[elev.id],

        key: elev.id,
        nume: elev.numeDeFamilie + ' ' + elev.initiala + ' ' + elev.prenume,
      });

      let obj = {};
      classData?.materii?.forEach((materieId) => {
        const materieData = materiiRedux?.find(
          (m) => m.id === materieId.materie
        );
        const materieNume = materieData?.numeMaterie;

        // Filtrează materiile de religie în funcție de tipul ales de elev
        if (
          materieNume === 'Religie' &&
          (elev?.religie === 'penticostala' || elev?.religie === 'nu')
        ) {
          return; // Nu adăuga religia normală
        }

        if (
          (materieNume === 'Religie Penticostală' ||
            materieData?.id?.includes('RP')) &&
          elev?.religie !== 'penticostala'
        ) {
          return; // Nu adăuga religia penticostală
        }

        obj[materieId.materie] = { note: [], absente: [] };
      });

      studentNotes?.forEach((n) => {
        obj[n.materieId]?.note?.push(n);
      });

      studentAbsente.absente_dupa_motivari.forEach((n) => {
        obj[n.materieId]?.absente?.push(n);
      });

      NotePrint.push({
        notes: Object.entries(obj),
        absente: studentAbsente,
        name: elev.numeDeFamilie + ' ' + elev.initiala + ' ' + elev.prenume,
        id: elev.id,
        retras: elev.retras,
        ces: elev.ces,
        details: elev.details,
        ...elev,
      });
    });

    setNotePrint(NotePrint);

    setScutiri(scutiriElevi);
    setEleviData([
      ...newArray
        .filter(
          (a) =>
            !(
              a.venitNou ||
              (a.transferuri?.length > 0 && !a.mutat && !a.retras)
            )
        )
        .sort((a, b) => a.nume.localeCompare(b.nume, 'ro')),
      ...newArray
        .filter(
          (a) =>
            a.venitNou || (a.transferuri?.length > 0 && !a.mutat && !a.retras)
        )
        .sort((a, b) => a.nume.localeCompare(b.nume, 'ro')),
    ]);

    setGradesElevi(note);
  };
  const decideNumber = () => {
    if (audit === true) return onlyWidth < 700 ? 1 : 2;
    if (onlyWidth < 700) return 1;
    if (onlyWidth < 900) return 2;
    if (onlyWidth < 1500) return 3;

    return 4;
  };
  const groupArray = (array) => {
    let newArray = [[]];
    let index = 0;
    (array || []).forEach((e) => {
      if (newArray[index].length < decideNumber()) newArray[index].push(e);
      else newArray[++index] = [e];
    });
    return newArray;
  };
  const exportToExcel = () => {
    // const worksheetData = [];
    // // Determinăm numărul maxim de note
    // let maxNotes = 0;
    // eleviData.forEach((elev) => {
    //   const noteElev = gradesElevi?.[elev.id]?.note?.filter(
    //     (n) =>
    //       n.tip === "nota" &&
    //       new Date(n.date) <= new Date("2024/12/21") &&
    //       classData?.materii?.find((m) => m.materie === n.materieId)
    //   );
    //   maxNotes = Math.max(maxNotes, noteElev?.length || 0);
    // });
    // // Header row
    // const headerRow = [
    //   "Elev",
    //   ...Array.from({ length: maxNotes }, (_, i) => `Nota ${i + 1}`),
    // ];
    // worksheetData.push(headerRow);
    // // Data rows
    // eleviData
    //   .sort((a, b) => a?.nume?.localeCompare(b.nume, "ro"))
    //   .forEach((elev) => {
    //     const row = [elev.nume];
    //     const noteElev =
    //       gradesElevi?.[elev.id].note
    //         .filter(
    //           (n) =>
    //             n.tip === "nota" &&
    //             new Date(n.date) <= new Date("2024/12/21") &&
    //             classData.materii?.find((m) => m.materie === n.materieId)
    //         )
    //         .sort((a, b) =>
    //           classData.materii?.findIndex((m) => m.materie === a.materieId) <
    //           classData.materii?.findIndex((m) => m.materie === b.materieId)
    //             ? -1
    //             : classData.materii?.findIndex(
    //                 (m) => m.materie === a.materieId
    //               ) ===
    //               classData.materii?.findIndex((m) => m.materie === b.materieId)
    //             ? a.date - b.date
    //             : 1
    //         )
    //         ?.filter(
    //           (n) =>
    //             n.tip === "nota" &&
    //             new Date(n.date) <= new Date("2024/12/21") &&
    //             new Date(n.date) >= new Date("2024/09/09") &&
    //             classData.materii?.find((m) => m.materie === n.materieId)
    //         ) || [];
    //     let total = 0;
    //     let count = 0;
    //     // Adăugăm notele elevului
    //     noteElev.forEach((nota) => {
    //       row.push(nota.nota);
    //     });
    //     // Completăm cu 0 dacă numărul de note este mai mic decât `maxNotes`
    //     for (let i = noteElev.length; i < maxNotes; i++) {
    //       row.push("");
    //     }
    //     worksheetData.push(row);
    //   });
    // const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    // const workbook = XLSX.utils.book_new();
    // XLSX.utils.book_append_sheet(workbook, worksheet, "Catalog");
    // XLSX.writeFile(workbook, `Catalog ${renderClassName(classData)}.xlsx`);
  };

  const formatDate = (today) => {
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1; // Months start at 0!
    let dd = today.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    return dd + '.' + mm;
  };
  useEffect(() => {
    fetchData();
    // setActiveMaterii(
    //   classData?.materii?.map((m) => {
    //     return m.materie;
    //   })
    // );
  }, [classData]);
  useEffect(() => {
    let array = [];
    for (let elev of classData?.elevi || []) {
      const unsub = onSnapshot(doc(db, 'catalog', elev.id), (doc) => {
        fetchData();
      });
      const unsub2 = onSnapshot(doc(db, 'eleviDocumente', elev.id), (doc) => {
        fetchData();
      });
      array.push(unsub);
      array.push(unsub2);
    }
  }, []);

  const fetchProfiles = async () => {
    let profileElevi = {};
    for await (let elev of classData?.elevi || []) {
      const profilElev = await getDataDoc('elevi', elev.id);
      profileElevi[elev.id] = profilElev;
    }
    setProfileElevi(profileElevi);
  };
  useEffect(() => {
    if (display === true) {
      fetchProfiles();
    }
  }, [display]);

  const materii = useSelector((state) => state.materii);

  return (
    <div className='modern-catalog'>
      {Object.keys(scutiri || {})?.find((key) => {
        if (
          scutiri[key]?.find(
            (s) =>
              s.verified === 'denied' &&
              (new Date() - new Date(s.uploaded)) / (1000 * 60 * 60 * 24) <= 30
          )
        )
          return true;
        return false;
      }) &&
        (user.type === 'admin' ||
          user.id === classData?.diriginte ||
          user.id === classData?.diriginte_step) && (
          <Alert
            type='error'
            message={
              'Elevii ' +
              (eleviData || []).reduce((acc, elev) => {
                let key = elev.key;

                if (
                  scutiri[key]?.find(
                    (s) =>
                      s.verified === 'denied' &&
                      (new Date() - new Date(s.uploaded)) /
                        (1000 * 60 * 60 * 24) <=
                        30
                  )
                )
                  return acc + ' ' + elev.nume + '; ';
                return acc;
              }, '') +
              ' au scutiri respinse de către conducere. Te rugăm să verifci.'
            }
          />
        )}

      <Modal
        size='tiny'
        open={openAveritzare}
        onClose={() => setOpenAvertizare(false)}
        style={{
          width: '90%',
          maxWidth: '350px',
          margin: 'auto',
          borderRadius: '12px',
        }}
      >
        <Modal.Header>Date necompletate</Modal.Header>
        <Modal.Content>
          <p style={{ color: 'red' }}>
            Parcurgeți întreaga listă de elevi și verificați fiecare elev care
            are un mesaj de avertizare afișat dedesubt. În cazul în care anumite
            informații nu sunt cunoscute, vă rugăm să introduceți caracterul
            (-). Datele care trebuie verificate sunt: numărul matricol,
            prenumele mamei, prenumele tatălui, numărul de telefon și
            domiciliul.
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setOpenAvertizare(false)} primary>
            Închide
          </Button>
        </Modal.Actions>
      </Modal>
      {eleviData?.find(
        (e) =>
          !e.numarTelefon ||
          !e.domiciliu ||
          !e.mama ||
          !e.tata ||
          !e.numarMatricol
      ) && (
        <Alert
          type='error'
          message={'Există elevi cu date necompletate'}
        ></Alert>
      )}
      <ModalAddGrade
        open={open}
        setOpen={setOpen}
        eleviData={eleviData}
        elevId={elevId}
        classData={classData}
        scutiri={scutiri}
        gradesElevi={gradesElevi}
        permision={permision}
        setElevId={setElevId}
        diriginteEmail={
          profesori?.find(
            (p) =>
              p?.id === classData?.diriginte ||
              p?.id === classData?.diriginte_step
          )?.adresaEmail || ''
        }
        classId={classData?.id}
        fullAcces={(() => {
          const currentClass = clase.find((c) => c.id === classData?.id);
          return (
            currentClass?.permisiuni?.diriginteToateNotele === true &&
            ((user.id || user.uid) === classData?.diriginte ||
              user.type === 'admin')
          );
        })()}
        dupaTermen={classData?.dupaTermen || false}
        materii={
          (() => {
            const currentClass = clase.find((c) => c.id === classData?.id);
            console.log(
              currentClass?.permisiuni,
              currentClass?.permisiuni?.diriginteToateNotele === true,

              (user.id || user.uid) === classData?.diriginte ||
                user.type === 'admin'
            );
            return (
              currentClass?.permisiuni?.diriginteToateNotele === true &&
              ((user.id || user.uid) === classData?.diriginte ||
                user.type === 'admin')
            );
          })()
            ? classData?.materii?.map((m) =>
                materiiRedux.find((c) => c.id === m?.materie)
              )
            : (() => {
                // Combină materiile clasei cu materiile specializate ale tuturor elevilor
                const materiiClasa = classData?.materii || [];
                const toateMateriileSpecializate = [];

                // Colectează toate materiile specializate ale elevilor
                eleviData.forEach((elev) => {
                  if (elev.materiiSpecialitate) {
                    elev.materiiSpecialitate.forEach((ms) => {
                      // Adaugă materia doar dacă nu există deja

                      if (
                        ms?.profesori?.find((c) => c === user.uid) &&
                        !toateMateriileSpecializate?.find(
                          (m) => m.materie === ms?.materie
                        )
                      ) {
                        toateMateriileSpecializate.push({
                          materie: ms?.materie,
                          profesori: ms?.profesori || [],
                        });
                      }
                    });
                  }
                });
                // Combină materiile clasei cu materiile specializate

                const materiiCombinate = [
                  ...materiiClasa,
                  ...toateMateriileSpecializate,
                ];
                return materiiCombinate
                  .filter((m) => {
                    if (m?.profesori?.find((p) => p === user.id)) return true;
                    if (
                      settings?.showPurtare === true &&
                      m?.materie?.toLowerCase().includes('purtare')
                    )
                      return true;
                    return false;
                  })
                  ?.map((matID) => {
                    return materii?.find((ma) => ma.id === matID.materie);
                  });
              })()
        }
      />
      <ModalTabularGrade
        open={openTabular}
        setOpen={setOpenTabular}
        eleviData={eleviData}
        materii={
          (() => {
            const currentClass = clase.find((c) => c.id === classData?.id);
            return (
              currentClass?.permisiuni?.diriginteToateNotele === true &&
              ((user.id || user.uid) === classData?.diriginte ||
                user.type === 'admin')
            );
          })()
            ? classData?.materii?.map((m) =>
                materiiRedux.find((c) => c.id === m?.materie)
              )
            : (() => {
                const materiiClasa = classData?.materii || [];
                const toateMateriileSpecializate = [];

                eleviData.forEach((elev) => {
                  if (elev.materiiSpecialitate) {
                    elev.materiiSpecialitate.forEach((ms) => {
                      if (
                        !toateMateriileSpecializate?.find(
                          (m) => m.materie === ms?.materie
                        )
                      ) {
                        toateMateriileSpecializate.push({
                          materie: ms?.materie,
                          profesori: ms?.profesori || [],
                        });
                      }
                    });
                  }
                });

                const materiiCombinate = [
                  ...materiiClasa,
                  ...toateMateriileSpecializate,
                ];

                return materiiCombinate
                  .filter((m) => {
                    if (m?.profesori?.find((p) => p === user.id)) return true;
                    if (
                      settings?.showPurtare === true &&
                      m?.materie?.toLowerCase().includes('purtare')
                    )
                      return true;
                    return false;
                  })
                  ?.map((matID) => {
                    return materii?.find((ma) => ma.id === matID.materie);
                  });
              })()
        }
        gradesElevi={gradesElevi}
        fullAcces={(() => {
          const currentClass = clase.find((c) => c.id === classData?.id);
          return (
            currentClass?.permisiuni?.diriginteToateNotele === true &&
            ((user.id || user.uid) === classData?.diriginte ||
              user.type === 'admin')
          );
        })()}
        dupaTermen={classData?.dupaTermen || false}
        scutiri={scutiri}
        classData={classData}
        classId={classData?.id}
        diriginteEmail={
          profesori?.find(
            (p) =>
              p?.id === classData?.diriginte ||
              p?.id === classData?.diriginte_step
          )?.adresaEmail || ''
        }
      />
      <ModalViewGrade
        open={open2}
        deleted={deleted || ''}
        setOpen={setOpen2}
        eleviData={eleviData}
        mode={mode}
        elevId={elevId2}
        allData={allData}
        id={id}
        gradesElevi={gradesElevi}
        author={author}
        entity={entity}
        permision={permision}
        setElevId={setElevId}
        classId={classData?.id}
        materiiClasa={(() => {
          // Combină materiile clasei cu materiile specializate ale tuturor elevilor
          const materiiClasa = classData?.materii || [];
          const toateMateriileSpecializate = [];

          // Colectează toate materiile specializate ale elevilor
          eleviData.forEach((elev) => {
            if (elev.materiiSpecialitate) {
              elev.materiiSpecialitate.forEach((ms) => {
                // Adaugă materia doar dacă nu există deja
                if (
                  !toateMateriileSpecializate?.find(
                    (m) => m.materie === ms?.materie
                  )
                ) {
                  toateMateriileSpecializate.push({
                    materie: ms?.materie,
                    profesori: ms?.profesori || [],
                  });
                }
              });
            }
          });

          // Combină materiile clasei cu materiile specializate
          const materiiCombinate = [
            ...materiiClasa,
            ...toateMateriileSpecializate,
          ];

          return materiiCombinate?.map((matID) => {
            return {
              ...(materii?.find((ma) => ma.id === matID.materie) || {}),
              profesori: matID.profesori,
            };
          });
        })()}
        materieId={materieId}
        tip={tip}
        nota={nota}
        teza={teza}
        comentariu={comentariu}
        date={data}
        scutiri={scutiri}
      />
      {(user?.type === 'admin' ||
        user?.id === classData?.diriginte ||
        user?.id === classData?.diriginte_step) &&
        new Date() >= new Date('2026-05-01') && (
          <Button
            type='primary'
            onClick={async () => {
              try {
                const zip = new JSZip();
                let processedCount = 0;

                // Calculate all medii once for ranking
                let medii = [];
                function sortFloat(a, b) {
                  return b - a;
                }

                for (let e of classData.elevi) {
                  const elevGrades = gradesElevi?.[e.id]?.note || [];
                  const elevScutiri = scutiri[e.id] || [];
                  medii.push(
                    parseFloat(
                      calculare_medii(elevGrades, materii, elevScutiri)
                    )
                  );
                }
                medii.sort(sortFloat);

                function findElementPosition(arr, element) {
                  const index = arr.indexOf(element);
                  return index === -1 ? -1 : index + 1;
                }

                for (let elev of classData.elevi) {
                  let elevId = elev.id;
                  let elevData = eleviData?.find((e) => e.id === elevId);
                  if (!elevData || elevData.retras === true) continue;

                  // Use existing absence data from component state
                  const studentGrades = gradesElevi?.[elevId]?.note || [];
                  const studentAbsences = gradesElevi?.[elevId]?.absente || {};
                  const studentScutiri = scutiri[elevId] || [];

                  // Determine student status (corigent, promovat)
                  const studentStatus = studentGrades
                    .filter((n) => n.tip === 'inchidere_medie')
                    .some((n) => n.inchidere_medie < 5)
                    ? 'corigent'
                    : 'promovat';

                  let resume = {
                    nume: elevData.numeDeFamilie,
                    prenume: elevData.prenume,
                    class: classData.anClasa + classData.identificator,
                    profil:
                      classData.identificator === 'B'
                        ? 'PEDAGOGIC'
                        : 'ARTISTIC',
                    medie:
                      classData.anClasa <= 4
                        ? ''
                        : calculare_medii(
                            studentGrades,
                            materii,
                            studentScutiri
                          ),
                    total_absente:
                      (studentAbsences.absente_motivate?.length || 0) +
                      (studentAbsences.absente_nemotivate?.length || 0),
                    nemotivate: studentAbsences.absente_nemotivate?.length || 0,
                    motivate: studentAbsences.absente_motivate?.length || 0,
                    diriginte:
                      profesori?.find((p) => p.id === classData?.diriginte)
                        ?.numeDeFamilie +
                      ' ' +
                      profesori?.find((p) => p.id === classData?.diriginte)
                        ?.prenume,
                    place: findElementPosition(
                      medii,
                      parseFloat(
                        calculare_medii(studentGrades, materii, studentScutiri)
                      )
                    ),
                    nr_elevi: classData.elevi?.length,
                    discipline: studentGrades
                      .filter((n) => n.tip === 'inchidere_medie')
                      .filter(
                        (n) =>
                          n.inchidere_medie < 8 ||
                          n.inchidere_medie === 'S' ||
                          n.inchidere_medie === 'I'
                      )
                      .reduce((acc, n) => {
                        return (
                          acc +
                          materii?.find((materie) => materie.id === n.materieId)
                            ?.numeMaterie +
                          ', '
                        );
                      }, '')
                      ?.slice(0, -2),
                    // Additional fields for corigent template
                    state: elevData.stareaLaIncheiereaCursurilor
                      ? elevData.stareaLaIncheiereaCursurilor
                          .charAt(0)
                          .toUpperCase() +
                        elevData.stareaLaIncheiereaCursurilor
                          .slice(1)
                          .toLowerCase()
                      : '',
                    cum:
                      elevData.stareaLaIncheiereaCursurilor
                        ?.trim()
                        .toLowerCase() === 'repetent'
                        ? 'corigent'
                        : elevData.stareaLaIncheiereaCursurilor
                            ?.trim()
                            .toLowerCase() === 'corigent'
                        ? 'corigent'
                        : elevData.stareaLaIncheiereaCursurilor
                            ?.trim()
                            .toLowerCase() === 'amanat'
                        ? 'amanat'
                        : '',
                    materii_sub: studentGrades
                      .filter((n) => n.tip === 'inchidere_medie')
                      .filter(
                        (n) =>
                          n.inchidere_medie < 5 ||
                          n.inchidere_medie === 'N' ||
                          !n.inchidere_medie
                      )
                      .reduce((acc, n) => {
                        return (
                          acc +
                          materii?.find((materie) => materie.id === n.materieId)
                            ?.numeMaterie +
                          ', '
                        );
                      }, '')
                      ?.slice(0, -2),
                  };

                  // Select appropriate template from settings
                  const templateUrl =
                    studentStatus === 'corigent'
                      ? settings?.instiintareCorigent ||
                        './instiintare parinti corigenti completat.docx'
                      : settings?.instiintare ||
                        './instiintare parenti 2025 completat.docx';

                  let doc = await generateDocument(resume, templateUrl);

                  if (doc) {
                    zip.file(
                      `${elevData.numeDeFamilie} ${elevData.prenume} instiintare.docx`,
                      doc,
                      { base64: true }
                    );
                    processedCount++;
                  }
                }

                if (processedCount > 0) {
                  const zipBlob = await zip.generateAsync({ type: 'blob' });
                  saveAs(
                    zipBlob,
                    `Instiintari_Clasa_${classData.anClasa}${classData.identificator}.zip`
                  );
                } else {
                  alert('Nu au fost procesate înștiințări.');
                }
              } catch (error) {
                console.error('Eroare la generarea înștiințărilor:', error);
                alert('A apărut o eroare la generarea înștiințărilor.');
              }
            }}
          >
            Descarcă înștiințări ca ZIP
          </Button>
        )}
      {inchideMediiAutomat === false &&
        new Date() >= new Date('2026-05-01') && (
          <Button
            onClick={() => {
              setInchideMediiAutomat(true);
            }}
          >
            Inchide medii automat
          </Button>
        )}

      {user.type === 'admin' && window.innerWidth > 768 && (
        <Button
          onClick={() => {
            setAudit(true);
            // handlePrint();
          }}
          type='primary'
          danger
        >
          Avansat
        </Button>
      )}

      {audit === true && (
        <>
          <br />
          <br />
          <Select
            mode='multiple'
            showSearch
            placeholder='Materii Alese'
            style={{ minWidth: '80%' }}
            optionFilterProp='children'
            value={activeMaterii}
            onChange={(value) => {
              setActiveMaterii(value);
            }}
            filterOption={(input, option) =>
              (option?.label?.toLowerCase() ?? '').includes(input.toLowerCase())
            }
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? '')
                .toLowerCase()
                .localeCompare((optionB?.label ?? '').toLowerCase())
            }
            options={classData?.materii?.map((m) => {
              return {
                label: materii?.find((ma) => ma.id === m.materie)?.numeMaterie,
                value: m.materie,
              };
            })}
          />
          <div
            ref={auditRef}
            style={{ textAlign: 'center', paddingTop: '100px' }}
          >
            <h2>Clasa: {renderClassName(classData)}</h2>
            {eleviData.filter((e) => {
              if (e.mutat === true || e.retras === true) return false;
              if (
                gradesElevi?.[e.id]?.absente?.absente_dupa_motivari?.length >
                Math.floor(
                  ((classData.ore?.length - 1) *
                    Math.floor(
                      (new Date() - new Date('2025-09-09')) /
                        (1000 * 60 * 60 * 24 * 7)
                    ) -
                    1) /
                    5
                )
              )
                return true;
              else return false;
            }).length > 0 && (
              <>
                {' '}
                <h3 style={{ textAlign: 'center' }}>
                  Elevii care au absentat mai mult de 20%
                </h3>
                {eleviData
                  .filter((e) => {
                    if (e.mutat === true || e.retras === true) return false;

                    if (
                      gradesElevi?.[e.id]?.absente?.absente_dupa_motivari
                        ?.length >
                      Math.floor(
                        ((classData.ore?.length - 2) *
                          Math.floor(
                            (new Date() - new Date('2024-09-09')) /
                              (1000 * 60 * 60 * 24 * 7)
                          ) -
                          1) /
                          5
                      )
                    )
                      return true;
                    else return false;
                  })
                  .sort((a, b) => {
                    return a?.nume?.localeCompare(b.nume, 'ro');
                  })

                  .map((e, index) => {
                    return (
                      <p>
                        {e.nume} :{' '}
                        {
                          gradesElevi?.[e.id]?.absente?.absente_dupa_motivari
                            .length
                        }{' '}
                        absente
                      </p>
                    );
                  })}
              </>
            )}
            <h3 style={{ textAlign: 'center' }}>
              Elevii care au prea putine note
            </h3>
            {eleviData
              .filter((e) => !e.mutat && !e.retras)
              .sort((a, b) => a?.nume?.localeCompare(b.nume, 'ro'))
              .map((e) => {
                let profesoriDeVerificat = profesori.filter((p) => {
                  return (
                    (p?.ore || []).some(
                      (o) =>
                        o.classId === classData.id &&
                        !o?.rule?.includes('COUNT') &&
                        !o?.rule?.includes('UNTIL')
                    ) || (p?.orePrivat || []).some((o) => o.elev === e.id)
                  );
                });

                let profesoriVinovati = [];

                profesoriDeVerificat.forEach((profesorData) => {
                  // Skip religie RP (Penticostală) dacă elevul nu face religie penticostală
                  if (
                    profesorData.selectedMaterii?.find((m) =>
                      m.includes('RP')
                    ) &&
                    e.religie !== 'penticostala'
                  ) {
                    return; // sarim religia RP dacă nu face penticostală
                  }

                  // Skip religie normală dacă elevul face religie penticostală sau nu face religie
                  if (
                    profesorData.selectedMaterii?.find(
                      (m) =>
                        !m.includes('RP') &&
                        materiiRedux.find((mat) => mat.id === m)
                          ?.numeMaterie === 'Religie'
                    ) &&
                    (e.religie === 'penticostala' || e.religie === 'nu')
                  ) {
                    return; // sarim religia normală dacă face penticostală sau nu face religie
                  }

                  let materiiProfesor = Array.from(
                    new Set([
                      ...(profesorData?.ore || [])
                        .filter(
                          (o) =>
                            o.classId === classData.id &&
                            !o?.rule?.includes('COUNT') &&
                            !o?.rule?.includes('UNTIL')
                        )
                        .map((o) => o.materieId),
                      ...classData.materii
                        .filter(
                          (m) =>
                            m.profesori?.find((p) => p === profesorData.id) ||
                            (settings?.showPurtare === true &&
                              materiiRedux
                                ?.find((mat) => mat.id === m?.materie)
                                ?.numeMaterie?.toLowerCase()
                                .includes('purtare'))
                        )
                        .map((m) => m.materie),
                    ])
                  );
                  console.log({ materiiProfesor });

                  materiiProfesor.forEach((materieId) => {
                    const noteElev = (gradesElevi?.[e.id]?.note || []).filter(
                      (n) =>
                        n.tip === 'nota' &&
                        n.materieId === materieId &&
                        (n.author === profesorData.displayName ||
                          n.authorId === profesorData.id ||
                          n.author === profesorData.id)
                    );

                    const oreMaterie = classData?.ore?.filter(
                      (o) =>
                        o.materieId === materieId &&
                        !materieId.includes('Teorie-') &&
                        !materieId.includes('Tehnologia') &&
                        !materieId.includes('Educa') &&
                        !o?.rule?.includes('COUNT') &&
                        !o?.rule?.includes('UNTIL')
                    );

                    const numarMinimNote = Math.max(4, oreMaterie?.length + 3);

                    if (
                      noteElev.length > 0 &&
                      noteElev.length < numarMinimNote
                    ) {
                      profesoriVinovati.push({
                        profesor: profesorData.displayName,
                        materieId,
                      });
                    }
                  });
                });

                if (profesoriVinovati?.length === 0) return null;

                return (
                  <div key={e.id}>
                    {profesoriVinovati.map((p, i) => {
                      const materie = materii?.find(
                        (m) => m.id === p.materieId
                      );
                      return (
                        <p key={i}>
                          {e.nume} — {materie?.numeMaterie || p.materieId} —{' '}
                          {p.profesor}
                        </p>
                      );
                    })}
                  </div>
                );
              })}
          </div>
          <Button
            onClick={() => {
              handlePrint();
            }}
          >
            Descarcă
          </Button>
        </>
      )}
      {inchideMediiAutomat === true &&
        (() => {
          // Combină materiile clasei cu materiile specializate ale tuturor elevilor
          const materiiClasa = classData?.materii || [];
          const toateMateriileSpecializate = [];

          // Colectează toate materiile specializate ale elevilor
          eleviData.forEach((elev) => {
            if (elev.materiiSpecialitate) {
              elev.materiiSpecialitate.forEach((ms) => {
                // Adaugă materia doar dacă nu există deja
                if (
                  !toateMateriileSpecializate?.find(
                    (m) => m.materie === ms?.materie
                  )
                ) {
                  toateMateriileSpecializate.push({
                    materie: ms?.materie,
                    profesori: ms?.profesori || [],
                  });
                }
              });
            }
          });

          // Combină materiile clasei cu materiile specializate
          const materiiCombinate = [
            ...materiiClasa,
            ...toateMateriileSpecializate,
          ];

          return materiiCombinate
            ?.filter((m) => {
              if (user.type === 'admin' && user.subType === 'director')
                return true;
              if (m?.profesori?.find((p) => p === user.id) || !m?.profesori)
                return true;
              return false;
            })
            ?.map((matID) => {
              return materii?.find((ma) => ma.id === matID.materie);
            });
        })()
          .filter((m) => {
            return !banned?.find((a) => a === m.numeMaterie);
          })
          .map((materie) => {
            return (
              <Popconfirm
                onConfirm={async () => {
                  if (!Array.isArray(eleviData) || !materie || !materie.id)
                    return;

                  await Promise.all(
                    eleviData.map(async (elev) => {
                      let elevId = elev.id;
                      let notaFinala = '';
                      let materieId = materie.id;

                      const noteElev = gradesElevi?.[elevId]?.note || [];

                      if (
                        noteElev?.find(
                          (n) =>
                            n.materieId === materieId &&
                            n.tip === 'inchidere_medie'
                        ) ||
                        noteElev?.filter(
                          (n) => n.materieId === materieId && n.tip === 'nota'
                        ).length <
                          (classData?.ore?.filter(
                            (o) =>
                              o.materieId === materieId &&
                              !materieId.includes('Teorie-') &&
                              !materieId.includes('Tehnologia') &&
                              !materieId.includes('Educa') &&
                              !o?.rule?.includes('COUNT') &&
                              !o?.rule?.includes('UNTIL')
                          ).length || 1) +
                            3 ||
                        elev.retras === true ||
                        elev.mutat === true ||
                        classData.freeze === true ||
                        noteElev?.filter(
                          (n) =>
                            n.materieId === materieId &&
                            n.tip === 'nota' &&
                            n.delete === 'waiting'
                        ).length > 0
                      )
                        return;

                      let medieFinala = calculeaza_medie_materie(
                        noteElev,
                        materii?.find((n) => n.id == materieId),
                        scutiri[elevId]
                      );

                      notaFinala = medieFinala.medie;

                      const updateObj = {
                        date: Date.now(),
                        id: Date.now() + 'dd',
                        comentariu: '',
                        materieId: materie.id,
                        author: user.displayName || user.uid || user.id,
                        displayName: user.numeDeFamilie + ' ' + user.prenume,
                        photoURL: user.photoLink || '',
                        tip: 'inchidere_medie',
                        inchidere_medie: notaFinala,
                      };

                      await updateDocDatabase('catalog', elevId, {
                        note: arrayUnion({
                          ...updateObj,
                        }),
                      });

                      let now = new Date();
                      let onejan = new Date(now.getFullYear(), 0, 1);
                      let week = Math.ceil(
                        ((now.getTime() - onejan.getTime()) / 86400000 +
                          onejan.getDay() +
                          1) /
                          7
                      );

                      await updateDocDatabase(
                        'changelog',
                        classData.id + 'week' + week,
                        {
                          changelog: arrayUnion({
                            author: user.displayName || user.uid || user.id,
                            time: Date.now(),
                            classId: classData.id,
                            elevId,
                            nota: updateObj,
                          }),
                        }
                      );

                      let dataElev = elev;
                      await updateDocDatabase('mail', elevId + Date.now(), {
                        to: [
                          dataElev.adresaEmail,
                          ...(dataElev.parintii || []),
                        ].filter((e) => e && !e.includes('dobriceansoftware')),
                        message: {
                          subject:
                            dataElev.numeDeFamilie +
                            ' ' +
                            dataElev.prenume +
                            ' a primit inchidere de medie',

                          html: `<code>
                                      <head>
                       <style>
                       table {
                        font-family: arial, sans-serif;
                        border-collapse: collapse;
                        width: 100%;
                      }
                      td, th {
                        border: 1px solid #dddddd;
                        text-align: left;
                        padding: 8px;
                      }
                      tr:nth-child(even) {
                        background-color: #dddddd;
                      }
                       </style>
                      </head>
                      <body>
                      <table>
                      <tr>
                        <th>Nume</th>
                        <th>Materie</th>
                        <th>Data</th>
                        <th>Medie Materie</th>
                        <th>Detalii</th>
                      </tr>
                      <tr>
                        <td>${
                          dataElev.numeDeFamilie + ' ' + dataElev.prenume
                        }</td>
                        <td>${
                          materii?.find((ma) => ma.id === materieId)
                            ?.numeMaterie || 'N/A'
                        }</td>
                        <td>${new Date().toLocaleDateString('ro-RO')}</td>
                        <td>${notaFinala}</td>
                        <td></td>
                      </tr>
                      </table>
                      </body></code>`,
                        },
                      });
                    })
                  );

                  openSuccesNotification('Ai inchis toate mediile!');
                }}
                description='Confirm că am verificat toate mediile că sunt calculate corect.'
              >
                <Button style={{ marginLeft: '2px' }}>
                  Inchide toate mediile la {materie?.numeMaterie}
                </Button>
              </Popconfirm>
            );
          })}

      {/* Action Buttons */}
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '12px',
          marginBottom: '20px',
          alignItems: 'center',
        }}
      >
        {(classData?.diriginte === user.uid ||
          classData?.diriginte === user.id ||
          classData?.diriginte_step === user.uid ||
          classData?.diriginte_step === user.id ||
          user.type === 'admin') && (
          <Button
            type='primary'
            style={{ backgroundColor: '#1890ff', borderColor: '#1890ff' }}
            onClick={() => setAddElev(true)}
            icon={<PlusOutlined />}
          >
            Adaugă Elev
          </Button>
        )}

        <Button
          type='primary'
          style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}
          onClick={() => setOpenTabular(true)}
          icon={<PlusOutlined />}
        >
          Atribuire Tabelar Note/Absențe
        </Button>
      </div>

      {/* Avertizare pentru elevi cu note în plus */}
      {(user.type === 'admin' ||
        (user.id || user.uid) === classData?.diriginte ||
        (user.id || user.uid) === classData?.diriginte_step) &&
        (() => {
          const eleviCuNotePlus = eleviData
            .filter((e) => {
              return gradesElevi?.[e.id]?.note?.some(
                (n) =>
                  (n.tip === 'nota' || n.tip === 'absenta') &&
                  !classData.materii?.find((a) => a.materie === n.materieId) &&
                  !e?.materiiSpecialitate?.find(
                    (a) => a.materie === n.materieId
                  )
              );
            })
            .map((e) => {
              const notePlus = gradesElevi?.[e.id]?.note?.filter(
                (n) =>
                  (n.tip === 'nota' || n.tip === 'absenta') &&
                  !classData.materii?.find((a) => a.materie === n.materieId) &&
                  !e?.materiiSpecialitate?.find(
                    (a) => a.materie === n.materieId
                  )
              );
              return {
                nume: e.nume,
                note:
                  notePlus?.map((n) => ({
                    id: n.id,
                    materieId: n.materieId,
                    materieNume:
                      materiiRedux?.find((m) => m.id === n.materieId)
                        ?.numeMaterie || 'Materie necunoscută',
                    tip: n.tip,
                    valoare:
                      n.valoare || (n.tip === 'absenta' ? 'Absență' : 'Notă'),
                    data: n.date
                      ? formatDate(new Date(n.date))
                      : n.data
                      ? formatDate(new Date(n.data))
                      : 'Fără dată',
                  })) || [],
              };
            });

          if (eleviCuNotePlus.length > 0) {
            return (
              <Alert
                message='⚠️ Atenție! Elevi cu note/absențe la materii care nu mai sunt în catalog'
                description={
                  <div>
                    <p style={{ marginBottom: '12px', fontWeight: '500' }}>
                      Următorii elevi au note sau absențe la materii care nu mai
                      există în catalogul acestei clase. Acestea pot fi note
                      rămase de la fostele specializări sau materii eliminate
                      din planul de învățământ.
                    </p>
                    <ul
                      style={{
                        marginBottom: '12px',
                        listStyle: 'none',
                        paddingLeft: 0,
                      }}
                    >
                      {eleviCuNotePlus.map((elev, idx) => (
                        <li
                          key={idx}
                          style={{
                            marginBottom: '12px',
                            padding: '8px',
                            backgroundColor: '#fff7e6',
                            borderRadius: '4px',
                            border: '1px solid #ffd591',
                          }}
                        >
                          <strong style={{ fontSize: '15px' }}>
                            {elev.nume}
                          </strong>
                          <div style={{ marginTop: '6px', fontSize: '13px' }}>
                            {elev.note.map((nota, nIdx) => (
                              <div
                                key={nIdx}
                                style={{ marginLeft: '12px', marginTop: '4px' }}
                              >
                                • <strong>{nota.materieNume}</strong> -{' '}
                                {nota.tip === 'nota'
                                  ? `Nota ${nota.valoare}`
                                  : 'Absență'}{' '}
                                - Data: {nota.data} (ID: {nota.id})
                              </div>
                            ))}
                          </div>
                        </li>
                      ))}
                    </ul>
                    <p
                      style={{
                        marginBottom: 0,
                        fontWeight: '500',
                        color: '#fa8c16',
                      }}
                    >
                      📞 Vă rugăm contactați administratorul pentru a șterge
                      aceste note/absențe sau pentru a adăuga materiile lipsă în
                      catalog.
                    </p>
                  </div>
                }
                type='warning'
                showIcon
                style={{ marginBottom: '20px' }}
              />
            );
          }
          return null;
        })()}

      <div className='catalog-table-container'>
        <CatalogTabel className='modern-catalog-table' celled>
          <CatalogTabel.Header className='catalog-table-header'>
            <CatalogTabel.Row>
              <CatalogTabel.HeaderCell>Nume</CatalogTabel.HeaderCell>
              <CatalogTabel.HeaderCell>Materii</CatalogTabel.HeaderCell>
            </CatalogTabel.Row>
          </CatalogTabel.Header>

          <CatalogTabel.Body>
            {eleviData
              .filter((e) => {
                // if (e.mutat === true || e.retras === true) return false; //show transferati
                // if (
                //   (user?.orePrivat?.length === 0 || user?.orePrivat) &&
                //   (!user?.ore || user?.ore?.length === 0)
                // )
                //   return true;

                if (user.type === 'admin') return true;

                // Verifică dacă profesorul predă cel puțin o materie la acest elev
                if (user.type === 'profesor') {
                  // Verifică în materiile clasei
                  const profesorInClasa = classData?.materii?.some((mc) =>
                    mc.profesori?.includes(user.id || user.uid)
                  );

                  // Verifică în materiile specializate ale elevului
                  const materiiSpecializateElev = e?.materiiSpecialitate || [];
                  const profesorInMateriiSpecializate =
                    materiiSpecializateElev.some((ms) =>
                      (ms?.profesori || []).includes(user.id || user.uid)
                    );

                  // Verifică dacă are acces la purtare
                  const areAccesLaPurtare =
                    settings?.showPurtare === true &&
                    classData?.materii?.some((mc) =>
                      materiiRedux?.find((m) => m.id === mc.materie)?.numeMaterie?.toLowerCase().includes('purtare')
                    );

                  // Dacă profesorul e în clasa generală, poate vedea toți elevii
                  if (profesorInClasa) return true;
                  // Dacă profesorul NU e în clasa generală, poate vedea doar elevii cu materii specializate
                  if (!profesorInClasa && profesorInMateriiSpecializate)
                    return true;
                  // Dacă profesorul are acces la purtare prin showPurtare, poate vedea toți elevii
                  if (areAccesLaPurtare) return true;
                }

                return false;
              })
              .sort((a, b) => {
                return a?.nume?.localeCompare(b.nume, 'ro');
              })

              .map((e, index) => {
                let materiiCuMediaDeschisa = classData?.materii?.filter((m) => {
                  if (new Date() < new Date('2026-06-01')) return true;
                  let inchis = (gradesElevi?.[e.id]?.note || [])?.find(
                    (n) =>
                      n.materieId === m.materie && n.tip === 'inchidere_medie'
                  );
                  if (inchis) return false;
                  if (
                    gradesElevi?.[e.id]?.note?.filter(
                      (n) => n.materieId === m.materie && n.tip === 'nota'
                    ).length > 0
                  )
                    return true;
                  else return false;
                });

                return (
                  <CatalogTabel.Row>
                    <CatalogTabel.Cell
                      style={{
                        position: 'relative',
                        whiteSpace: 'break-spaces',

                        textAlign: 'center',
                      }}
                    >
                      <a
                        id={e.id}
                        onClick={() => {
                          // Adaugă #id în URL-ul curent
                          const currentUrl = new URL(window.location.href);
                          currentUrl.hash = e.id;
                          window.history.replaceState(
                            null,
                            '',
                            currentUrl.toString()
                          );

                          // Navighează către pagina elevului
                          navigate(`/elev/${e.id}`);
                        }}
                        className='sentry-mask'
                        style={{
                          textAlign: 'center',
                          display: 'flex',
                          justifyContent: 'center',
                          border:
                            (materiiCuMediaDeschisa?.length === 0 ||
                              e.incheie === true) &&
                            new Date() >= new Date('2026-05-15')
                              ? '1px solid purple'
                              : 'none',
                        }}
                      >
                        {index + 1}. {e.nume}
                        {e?.retras === true || e?.mutat === true
                          ? ' - transferat'
                          : ''}
                      </a>
                      {(!e?.mama ||
                        !e?.tata ||
                        !e?.domiciliu ||
                        !e?.numarTelefon ||
                        !e?.numarMatricol) && (
                        <p style={{ color: 'red' }}>Date lipsă</p>
                      )}
                      {e?.ces === 'da' && (
                        <p
                          style={{
                            fontSize: '12px',
                            color: 'red',
                            padding: 0,
                            margin: 0,
                          }}
                        >
                          Cerințe educaționale speciale
                        </p>
                      )}
                      <p
                        style={{
                          fontSize: '12px',
                          color: 'red',
                        }}
                      >
                        {(() => {
                          // Funcție pentru deduplicarea mesajelor de transfer
                          const deduplicateTransferMessages = (text) => {
                            if (!text) return '';

                            // Împărțim textul în linii
                            const lines = text
                              .split('\n')
                              .map((line) => line.trim())
                              .filter((line) => line);

                            // Folosim un Set pentru a ține evidența mesajelor unice
                            const uniqueLines = new Set();
                            const result = [];

                            lines.forEach((line) => {
                              // Normalizăm linia pentru comparație (eliminăm spații extra)
                              const normalizedLine = line
                                .replace(/\s+/g, ' ')
                                .trim();

                              // Dacă linia nu a fost văzută, o adăugăm
                              if (!uniqueLines.has(normalizedLine)) {
                                uniqueLines.add(normalizedLine);
                                result.push(line);
                              }
                            });

                            return result.join('\n');
                          };

                          const transferuri = e.transferuri || [];
                          const hasTransferuri = transferuri.length > 0;

                          // Dacă avem transferuri, nu mai afișăm detalii care conțin "transferat"
                          let detaliiText = '';
                          if (!hasTransferuri) {
                            detaliiText = e.details || e.detalii || '';
                          } else {
                            // Filtrăm detalii dacă conțin "transferat"
                            const detalii = e.details || e.detalii || '';
                            if (!detalii.toLowerCase().includes('transferat')) {
                              detaliiText = detalii;
                            }
                          }

                          // Adăugăm informații din transferuri
                          const transferuriText = transferuri
                            .map((cur) => cur.details || '')
                            .filter((d) => d.trim())
                            .join('\n');

                          // Combinăm și deduplicăm toate mesajele
                          const combinedText =
                            detaliiText +
                            (detaliiText && transferuriText ? '\n' : '') +
                            transferuriText;
                          return deduplicateTransferMessages(combinedText);
                        })()}
                      </p>
                      {new Date() > new Date('2024-10-01') &&
                        (user.type === 'admin' ||
                          (user.id || user.uid) === classData?.diriginte) &&
                        gradesElevi?.[e.id]?.absente?.absente_dupa_motivari
                          .length >
                          Math.floor(
                            (classData.ore?.length *
                              Math.floor(
                                (new Date() - new Date('2024-09-09')) /
                                  (1000 * 60 * 60 * 24 * 7)
                              )) /
                              5
                          ) &&
                        classData?.ore?.length > 0 && (
                          <>
                            {' '}
                            <p style={{ color: 'red', fontSize: '15px' }}>
                              Elevul a absentat la mai mult de 20% din ore
                            </p>
                          </>
                        )}

                      {!e.retras && !e.deleted && !e.mutat && (
                        <Button
                          style={{ backgroundColor: '#003d82', color: 'white' }}
                          onClick={() => {
                            setOpen(true);
                            setElevId(e.id);
                          }}
                        >
                          <PlusOutlined />
                        </Button>
                      )}
                    </CatalogTabel.Cell>
                    <CatalogTabel.Cell>
                      <Accordion>
                        <Accordion.Title
                          active={activeIndex === index}
                          index={index}
                          onClick={() => {
                            if (index === activeIndex) setActiveIndex(-1);
                            else setActiveIndex(index);
                          }}
                          style={{ textAlign: 'center' }}
                        >
                          {window.screen.width < 750 ? (
                            <>
                              {' '}
                              <Icon name='dropdown' />
                              Note
                            </>
                          ) : (
                            <></>
                          )}
                        </Accordion.Title>
                        <Accordion.Content
                          active={
                            window.screen.width < 750 &&
                            classData?.materii?.length > 3
                              ? activeIndex === index
                              : true
                          }
                        >
                          {groupArray(
                            (() => {
                              // Combinează materiile clasei cu materiile specializate ale elevului
                              const materiiClasa = classData?.materii || [];
                              const materiiSpecializateElev =
                                e?.materiiSpecialitate || [];

                              // Creează array pentru materiile specializate în formatul așteptat
                              const materiiSpecializateFormatate =
                                materiiSpecializateElev.map((ms) => ({
                                  materie: ms?.materie,
                                  profesori: ms?.profesori || [],
                                }));

                              // Combină materiile, evitând duplicatele
                              const materiiCombinate = [...materiiClasa];
                              materiiSpecializateFormatate.forEach((ms) => {
                                if (
                                  !materiiCombinate?.find(
                                    (mc) => mc.materie === ms?.materie
                                  )
                                ) {
                                  materiiCombinate.push(ms);
                                }
                              });

                              return materiiCombinate
                                .filter((a) => {
                                  // Filtru pentru materiile active
                                  if (
                                    activeMaterii?.length > 0 &&
                                    !activeMaterii?.find((s) => s == a.materie)
                                  ) {
                                    return false;
                                  }

                                  // Filtru pentru materiile de religie în funcție de tipul ales de elev
                                  const materieData = materiiRedux?.find(
                                    (m) => m.id === a.materie
                                  );
                                  const materieNume = materieData?.numeMaterie;

                                  if (
                                    materieNume === 'Religie' &&
                                    (e?.religie === 'penticostala' ||
                                      e?.religie === 'nu')
                                  ) {
                                    return false; // Nu afișa religia normală
                                  }

                                  if (
                                    (materieNume === 'Religie Penticostală' ||
                                      materieData?.id?.includes('RP')) &&
                                    e?.religie !== 'penticostala'
                                  ) {
                                    return false; // Nu afișa religia penticostală
                                  }

                                  // Filtru pentru permisiuni profesor
                                  if (
                                    user.type === 'profesor' &&
                                    !(
                                      classData?.diriginte === user.uid ||
                                      classData?.diriginte_step === user.uid ||
                                      classData?.diriginte === user.id ||
                                      classData?.diriginte_step === user.id
                                    )
                                  ) {
                                    // Verifică dacă profesorul predă în clasa generală
                                    const profesorInClasa =
                                      classData?.materii?.some(
                                        (mc) =>
                                          mc.materie === a.materie &&
                                          mc.profesori?.includes(
                                            user.id || user.uid
                                          )
                                      );

                                    // Verifică dacă profesorul predă această materie specializată pentru acest elev
                                    const profesorInMaterieSpecializata =
                                      e?.materiiSpecialitate?.some(
                                        (ms) =>
                                          ms?.materie === a.materie &&
                                          ms?.profesori?.includes(
                                            user.id || user.uid
                                          )
                                      );

                                    // Verifică dacă este purtare și showPurtare este activat
                                    const estePurtareCuAcces =
                                      settings?.showPurtare === true &&
                                      materieNume?.toLowerCase().includes('purtare');

                                    // Afișează materia doar dacă profesorul o predă sau dacă este purtare cu acces
                                    if (
                                      !profesorInClasa &&
                                      !profesorInMaterieSpecializata &&
                                      !estePurtareCuAcces
                                    ) {
                                      return false;
                                    }
                                  }
                                  if (
                                    user.type === 'profesor' ||
                                    user.type === 'admin'
                                  )
                                    return true;
                                })
                                .sort((a, b) => {
                                  // Sortare: classData (fără purtare) → materii specializate → purtare
                                  const materieDataA = materiiRedux?.find(
                                    (m) => m.id === a.materie
                                  );
                                  const materieDataB = materiiRedux?.find(
                                    (m) => m.id === b.materie
                                  );
                                  const numeA = materieDataA?.numeMaterie || '';
                                  const numeB = materieDataB?.numeMaterie || '';

                                  // Verifică dacă sunt materii din classData
                                  const aEsteClassData =
                                    classData?.materii?.some(
                                      (mc) => mc.materie === a.materie
                                    );
                                  const bEsteClassData =
                                    classData?.materii?.some(
                                      (mc) => mc.materie === b.materie
                                    );

                                  // Verifică dacă sunt materii specializate ale elevului
                                  const aEsteSpecializata =
                                    e?.materiiSpecialitate?.some(
                                      (ms) => ms?.materie === a.materie
                                    );
                                  const bEsteSpecializata =
                                    e?.materiiSpecialitate?.some(
                                      (ms) => ms?.materie === b.materie
                                    );

                                  // Verifică dacă sunt purtare
                                  const aEstePurtare = numeA
                                    .toLowerCase()
                                    .includes('purtare');
                                  const bEstePurtare = numeB
                                    .toLowerCase()
                                    .includes('purtare');

                                  // Purtarea merge la sfârșit
                                  if (aEstePurtare && !bEstePurtare) return 1;
                                  if (bEstePurtare && !aEstePurtare) return -1;
                                  if (aEstePurtare && bEstePurtare) return 0;

                                  // Materiile din classData (fără purtare) vin primele
                                  if (
                                    aEsteClassData &&
                                    !aEstePurtare &&
                                    bEsteSpecializata &&
                                    !aEsteSpecializata
                                  )
                                    return -1;
                                  if (
                                    bEsteClassData &&
                                    !bEstePurtare &&
                                    aEsteSpecializata &&
                                    !bEsteSpecializata
                                  )
                                    return 1;

                                  // Dacă ambele sunt din classData sau ambele specializate, păstrează ordinea originală
                                  return 0;
                                });
                            })()
                          ).map((group) => {
                            return (
                              <CatalogTabel attached celled fixed>
                                <CatalogTabel.Header>
                                  <CatalogTabel.Row>
                                    {group.map((m) => {
                                      return (
                                        <CatalogTabel.HeaderCell>
                                          {
                                            materii?.find(
                                              (ma) => ma.id === m.materie
                                            )?.numeMaterie
                                          }
                                        </CatalogTabel.HeaderCell>
                                      );
                                    })}
                                  </CatalogTabel.Row>
                                </CatalogTabel.Header>
                                <CatalogTabel.Body>
                                  <CatalogTabel.Row>
                                    {group.map((m) => {
                                      let medie = calculeaza_medie_materie(
                                        gradesElevi?.[e.id]?.note,
                                        materii?.find((n) => n.id == m.materie),
                                        scutiri[e.id]
                                      );
                                      let { corigenta, inchis } = medie;

                                      return (
                                        <CatalogTabel.Cell>
                                          <CatalogTabel attached celled fixed>
                                            <CatalogTabel.Body>
                                              <CatalogTabel.Row
                                                style={{
                                                  borderBottom:
                                                    '1px solid black',
                                                  backgroundColor: 'unset',
                                                  //activeaza doar daca vrei sa arati ca nu sunt suficiente note
                                                  // (
                                                  //   gradesElevi?.[e.id]?.note ||
                                                  //   []
                                                  // ).filter(
                                                  //   (n) =>
                                                  //     n.tip === "nota" &&
                                                  //     n.materieId === m.materie
                                                  // ).length > 0 &&
                                                  // (
                                                  //   gradesElevi?.[e.id]?.note ||
                                                  //   []
                                                  // ).filter(
                                                  //   (n) =>
                                                  //     n.tip === "nota" &&
                                                  //     n.materieId === m.materie
                                                  // ).length < 4 &&
                                                  // (
                                                  //   gradesElevi?.[e.id]?.note ||
                                                  //   []
                                                  // ).filter(
                                                  //   (n) =>
                                                  //     n.tip === "corigenta" &&
                                                  //     n.materieId === m.materie
                                                  // ).length === 0
                                                  //   ? "#eb9371"
                                                  //   : "unset",
                                                }}
                                              >
                                                <CatalogTabel.Cell>
                                                  <div
                                                    style={{
                                                      display: 'grid',
                                                      gridTemplateColumns:
                                                        'auto auto auto ',
                                                    }}
                                                  >
                                                    {(
                                                      gradesElevi?.[e.id]
                                                        ?.note || []
                                                    )
                                                      .filter(
                                                        (n) =>
                                                          n.tip === 'nota' &&
                                                          n.materieId ===
                                                            m.materie
                                                      )
                                                      .sort(
                                                        (a, b) =>
                                                          new Date(a.date) -
                                                          new Date(b.date)
                                                      )
                                                      .map((nota) => (
                                                        <p
                                                          style={{
                                                            fontSize: '18px',
                                                            color:
                                                              nota?.delete ===
                                                              'waiting'
                                                                ? 'grey'
                                                                : '#1c90ff',
                                                          }}
                                                          onClick={() => {
                                                            setAllData(nota);
                                                            setNota(nota.nota);
                                                            setMaterieId(
                                                              nota.materieId
                                                            );
                                                            setTip(nota.tip);
                                                            setDeleted(
                                                              nota?.delete
                                                            );
                                                            setAuthor(
                                                              nota.author || ''
                                                            );
                                                            setComentariu(
                                                              nota.comentariu
                                                            );
                                                            setId(nota.id);
                                                            setData(
                                                              new Date(
                                                                nota.date
                                                              )
                                                            );
                                                            setElevId2(e.id);
                                                            setOpen2(true);
                                                          }}
                                                        >
                                                          {audit === true ? (
                                                            <div
                                                              style={{
                                                                display: 'flex',
                                                              }}
                                                            >
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    '18px',
                                                                }}
                                                              >
                                                                {nota.nota} /
                                                              </p>

                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    '14px',
                                                                  paddingTop:
                                                                    '5px',
                                                                  color:
                                                                    'black',
                                                                }}
                                                              >
                                                                {' '}
                                                                {formatDate(
                                                                  new Date(
                                                                    nota.date
                                                                  )
                                                                )}
                                                              </p>
                                                            </div>
                                                          ) : (
                                                            nota.nota
                                                          )}
                                                        </p>
                                                      ))}
                                                  </div>
                                                  {(
                                                    gradesElevi?.[e.id]?.note ||
                                                    []
                                                  )?.find(
                                                    (n) =>
                                                      n.materieId ===
                                                        m.materie &&
                                                      n.tip === 'examen_final'
                                                  ) && (
                                                    <p
                                                      style={{
                                                        color:
                                                          (
                                                            gradesElevi?.[e.id]
                                                              ?.note || []
                                                          )?.find(
                                                            (n) =>
                                                              n.materieId ===
                                                                m.materie &&
                                                              n.tip ===
                                                                'examen_final'
                                                          )?.delete ===
                                                          'waiting'
                                                            ? 'grey'
                                                            : 'purple',
                                                      }}
                                                      onClick={() => {
                                                        const nota = (
                                                          gradesElevi?.[e.id]
                                                            ?.note || []
                                                        )?.find(
                                                          (n) =>
                                                            n.materieId ===
                                                              m.materie &&
                                                            n.tip ===
                                                              'examen_final'
                                                        );
                                                        setAllData(nota);
                                                        setNota(
                                                          nota.examen_final
                                                        );
                                                        setMaterieId(
                                                          nota.materieId
                                                        );
                                                        setTip(nota.tip);
                                                        setDeleted(
                                                          nota?.delete
                                                        );
                                                        setAuthor(
                                                          nota.author || ''
                                                        );
                                                        setComentariu(
                                                          nota.comentariu
                                                        );
                                                        setId(nota.id);
                                                        setData(
                                                          new Date(nota.date)
                                                        );
                                                        setElevId2(e.id);
                                                        setOpen2(true);
                                                      }}
                                                    >
                                                      Ex.Final:
                                                      {
                                                        (
                                                          gradesElevi?.[e.id]
                                                            ?.note || []
                                                        )?.find(
                                                          (n) =>
                                                            n.materieId ===
                                                              m.materie &&
                                                            n.tip ===
                                                              'examen_final'
                                                        ).examen_final
                                                      }
                                                    </p>
                                                  )}
                                                  {corigenta && (
                                                    <p
                                                      style={{
                                                        fontSize: '14px',
                                                        color: 'delete =',
                                                        paddingTop: '5px',
                                                        borderTop:
                                                          '1px solid black',
                                                      }}
                                                    >
                                                      Media intiala:{' '}
                                                      {medie.medieInitiala}
                                                    </p>
                                                  )}
                                                  {corigenta && (
                                                    <p
                                                      style={{
                                                        fontSize: '14px',

                                                        paddingTop: '5px',
                                                        borderTop:
                                                          '1px solid black',
                                                        color:
                                                          nota?.delete ===
                                                          'waiting'
                                                            ? 'grey'
                                                            : 'purple',
                                                      }}
                                                      onClick={() => {
                                                        setAllData(corigenta);
                                                        setNota(
                                                          corigenta?.corigenta
                                                        );
                                                        setMaterieId(
                                                          corigenta?.materieId
                                                        );
                                                        setTip(corigenta?.tip);
                                                        setDeleted(
                                                          corigenta?.delete
                                                        );
                                                        setAuthor(
                                                          corigenta?.author ||
                                                            ''
                                                        );
                                                        setComentariu(
                                                          corigenta?.comentariu
                                                        );
                                                        setId(corigenta?.id);
                                                        setData(
                                                          new Date(
                                                            corigenta?.date
                                                          )
                                                        );
                                                        setElevId2(e.id);
                                                        setOpen2(true);
                                                      }}
                                                    >
                                                      {medie.noteInsuficiente
                                                        ? 'Medie neîncheiat:'
                                                        : 'Media corigenta:'}{' '}
                                                      {corigenta.corigenta}
                                                    </p>
                                                  )}
                                                  <Space>
                                                    {materii
                                                      ?.find(
                                                        (ma) =>
                                                          ma.id === m?.materie
                                                      )
                                                      ?.numeMaterie?.toLowerCase()
                                                      .includes(
                                                        'educație fizică'
                                                      ) &&
                                                      e?.scutitMedical?.length >
                                                        0 &&
                                                      e?.scutitMedical?.length >
                                                        0 &&
                                                      (e?.dataExpirareMedical
                                                        ? new Date() <=
                                                          new Date(
                                                            e.dataExpirareMedical
                                                          )
                                                        : true) &&
                                                      e.scutitMedical !==
                                                        'nu' && (
                                                        <p
                                                          style={{
                                                            color: 'red',
                                                            fontSize: '12px',
                                                          }}
                                                        >
                                                          -scutit medical
                                                          conform{' '}
                                                          {e.scutitMedical}-
                                                        </p>
                                                      )}
                                                    Medie:
                                                    {inchis ? (
                                                      <>
                                                        {edit !== inchis?.id ? (
                                                          <>
                                                            <p
                                                              style={{
                                                                border:
                                                                  '1px solid purple',
                                                                width: 'auto',
                                                                fontSize:
                                                                  '20px',
                                                                textAlign:
                                                                  'center',
                                                                display: 'flex',
                                                                justifyContent:
                                                                  'center',
                                                              }}
                                                              onClick={() => {
                                                                if (
                                                                  user.type ===
                                                                    'admin' ||
                                                                  m?.profesori?.find(
                                                                    (p) =>
                                                                      p ===
                                                                      user.id
                                                                  )
                                                                )
                                                                  setEdit(
                                                                    inchis?.id
                                                                  );
                                                              }}
                                                            >
                                                              {
                                                                inchis.inchidere_medie
                                                              }
                                                            </p>
                                                          </>
                                                        ) : (
                                                          <div>
                                                            <p>
                                                              Vrei sa redeschizi
                                                              media?
                                                            </p>

                                                            <Button
                                                              danger
                                                              onClick={() => {
                                                                setEdit(null);
                                                              }}
                                                            >
                                                              Nu
                                                            </Button>
                                                            <Popconfirm
                                                              description={
                                                                <div
                                                                  style={{
                                                                    width:
                                                                      '300px',
                                                                  }}
                                                                >
                                                                  Preciseaza
                                                                  motivul
                                                                  <br />
                                                                  <input
                                                                    value={
                                                                      motivStergereMedie
                                                                    }
                                                                    style={{
                                                                      border:
                                                                        '1px solid grey',
                                                                      width:
                                                                        '80%',
                                                                      height:
                                                                        '50px',
                                                                    }}
                                                                    onChange={(
                                                                      e
                                                                    ) =>
                                                                      setMotivStergereMedie(
                                                                        e.target
                                                                          .value
                                                                      )
                                                                    }
                                                                  />
                                                                </div>
                                                              }
                                                              onConfirm={async () => {
                                                                if (
                                                                  motivStergereMedie?.length ===
                                                                    0 ||
                                                                  motivStergereMedie ==
                                                                    ''
                                                                ) {
                                                                  openErrorNotification(
                                                                    'Trebuie sa precisezi un motiv'
                                                                  );
                                                                  return;
                                                                }
                                                                let now =
                                                                  new Date();
                                                                let onejan =
                                                                  new Date(
                                                                    now.getFullYear(),
                                                                    0,
                                                                    1
                                                                  );
                                                                let week =
                                                                  Math.ceil(
                                                                    ((now.getTime() -
                                                                      onejan.getTime()) /
                                                                      86400000 +
                                                                      onejan.getDay() +
                                                                      1) /
                                                                      7
                                                                  );
                                                                let changelogGet =
                                                                  await getDataDoc(
                                                                    'changelog',
                                                                    classData.id +
                                                                      'week' +
                                                                      week
                                                                  );
                                                                let previous =
                                                                  [];
                                                                if (
                                                                  changelogGet
                                                                )
                                                                  previous =
                                                                    changelogGet;

                                                                await updateDocDatabase(
                                                                  'changelog',
                                                                  classData.id +
                                                                    'week' +
                                                                    week,
                                                                  {
                                                                    changelog: [
                                                                      ...(previous.changelog ||
                                                                        []),
                                                                      {
                                                                        author:
                                                                          user.displayName,
                                                                        time: Date.now(),
                                                                        classId:
                                                                          classData.id,
                                                                        materieId:
                                                                          inchis.materieId,
                                                                        motiv:
                                                                          'Am redeschis media pentru că: ' +
                                                                          motivStergereMedie,
                                                                        elevId:
                                                                          e.id,
                                                                        nota: {
                                                                          tip: 'inchidere_medie',
                                                                          inchidere_medie:
                                                                            inchis.inchidere_medie,
                                                                          materieId:
                                                                            inchis.materieId,
                                                                        },
                                                                        sterge: true,
                                                                      },
                                                                    ],
                                                                  }
                                                                );

                                                                setMotivStergereMedie(
                                                                  ''
                                                                );

                                                                await updateDocDatabase(
                                                                  'catalog',
                                                                  e.id,
                                                                  {
                                                                    note: [
                                                                      ...(
                                                                        gradesElevi?.[
                                                                          e.id
                                                                        ]
                                                                          ?.note ||
                                                                        []
                                                                      ).filter(
                                                                        (n) =>
                                                                          n.id !==
                                                                          inchis.id
                                                                      ),
                                                                    ],
                                                                  }
                                                                ).then(() => {
                                                                  openSuccesNotification(
                                                                    'Ai redeschis media'
                                                                  );
                                                                });
                                                                setOpen(false);
                                                                setEdit(null);
                                                              }}
                                                            >
                                                              <Button type='primary'>
                                                                DA
                                                              </Button>
                                                            </Popconfirm>
                                                          </div>
                                                        )}
                                                      </>
                                                    ) : (
                                                      <>
                                                        {corigenta ? (
                                                          <p
                                                            style={{
                                                              color: 'green',
                                                              textAlign:
                                                                'center',
                                                              fontSize: '20px',
                                                            }}
                                                            onClick={() => {
                                                              setAllData(
                                                                corigenta
                                                              );
                                                              setNota(
                                                                corigenta?.corigenta
                                                              );
                                                              setMaterieId(
                                                                corigenta?.materieId
                                                              );
                                                              setTip(
                                                                corigenta?.tip
                                                              );
                                                              setDeleted(
                                                                corigenta?.delete
                                                              );
                                                              setAuthor(
                                                                corigenta?.author ||
                                                                  ''
                                                              );
                                                              setComentariu(
                                                                corigenta?.comentariu
                                                              );
                                                              setId(
                                                                corigenta?.id
                                                              );
                                                              setData(
                                                                new Date(
                                                                  corigenta?.date
                                                                )
                                                              );
                                                              setElevId2(e.id);
                                                              setOpen2(true);
                                                            }}
                                                          >
                                                            {
                                                              corigenta.corigenta
                                                            }
                                                          </p>
                                                        ) : (
                                                          <p
                                                            style={{
                                                              fontSize: '30px',
                                                              textAlign:
                                                                'center',
                                                              display: 'flex',
                                                              justifyContent:
                                                                'center',
                                                            }}
                                                          >
                                                            {medie.medie}
                                                          </p>
                                                        )}
                                                      </>
                                                    )}
                                                  </Space>
                                                </CatalogTabel.Cell>
                                                <CatalogTabel.Cell>
                                                  <div
                                                    style={{
                                                      display: 'grid',

                                                      gridTemplateColumns:
                                                        'auto auto ',
                                                    }}
                                                  >
                                                    {gradesElevi?.[
                                                      e.id
                                                    ]?.absente?.absente_dupa_motivari
                                                      .filter(
                                                        (abs) =>
                                                          abs.materieId ===
                                                          m.materie
                                                      )
                                                      .sort(
                                                        (a, b) =>
                                                          new Date(a.date) -
                                                          new Date(b.date)
                                                      )
                                                      ?.map((nota) => {
                                                        let date = new Date(
                                                          nota.date
                                                        );
                                                        return nota.motivat ===
                                                          false ? (
                                                          <p
                                                            style={{
                                                              fontSize: '15px',
                                                              color:
                                                                nota?.delete ===
                                                                'waiting'
                                                                  ? 'grey'
                                                                  : 'red',
                                                            }}
                                                            onClick={() => {
                                                              setAllData(nota);
                                                              setId(nota.id);
                                                              setMaterieId(
                                                                nota.materieId
                                                              );
                                                              setTip(nota.tip);
                                                              setDeleted(
                                                                nota?.delete
                                                              );
                                                              setAuthor(
                                                                nota.author ||
                                                                  ''
                                                              );
                                                              setComentariu(
                                                                nota.comentariu
                                                              );
                                                              setData(
                                                                new Date(
                                                                  nota.date
                                                                )
                                                              );
                                                              setElevId2(e.id);
                                                              setEntity(nota);
                                                              setOpen2(true);
                                                            }}
                                                          >
                                                            {formatDate(date)}
                                                          </p>
                                                        ) : (
                                                          <p
                                                            className='absence-date-tag'
                                                            style={{
                                                              fontSize: '15px',

                                                              border:
                                                                nota?.scutire
                                                                  ?.tip ===
                                                                'bilet'
                                                                  ? '2.5px solid #a3eb07'
                                                                  : '1px solid green',

                                                              borderStyle:
                                                                nota?.scutire
                                                                  ?.tip ===
                                                                'bilet'
                                                                  ? 'dotted'
                                                                  : 'solid',

                                                              wordBreak:
                                                                'keep-all',
                                                              borderRadius:
                                                                '2px',
                                                              maxWidth: '40px',
                                                              color:
                                                                nota?.delete ===
                                                                'waiting'
                                                                  ? 'grey'
                                                                  : 'green',
                                                            }}
                                                            onClick={() => {
                                                              setAllData(nota);
                                                              setMaterieId(
                                                                nota.materieId
                                                              );
                                                              setTip(nota.tip);
                                                              setDeleted(
                                                                nota?.delete
                                                              );

                                                              setAuthor(
                                                                nota.author ||
                                                                  ''
                                                              );
                                                              setId(nota.id);
                                                              setComentariu(
                                                                nota.comentariu
                                                              );
                                                              setData(
                                                                new Date(
                                                                  nota.date
                                                                )
                                                              );
                                                              setElevId2(e.id);
                                                              setOpen2(true);
                                                              setEntity(nota);
                                                            }}
                                                          >
                                                            {formatDate(date)}
                                                          </p>
                                                        );
                                                      })}
                                                  </div>
                                                </CatalogTabel.Cell>
                                              </CatalogTabel.Row>
                                            </CatalogTabel.Body>
                                          </CatalogTabel>
                                        </CatalogTabel.Cell>
                                      );
                                    })}
                                  </CatalogTabel.Row>
                                </CatalogTabel.Body>
                              </CatalogTabel>
                            );
                          })}
                        </Accordion.Content>
                      </Accordion>
                    </CatalogTabel.Cell>
                    {permision === true && (
                      <CatalogTabel.Cell style={{ textAlign: 'center' }}>
                        <p style={{ textAlign: 'center' }}>
                          <p
                            style={{
                              textAlign: 'center',
                              color:
                                materiiCuMediaDeschisa?.length === 0
                                  ? 'red'
                                  : 'black',
                            }}
                          >
                            {materiiCuMediaDeschisa?.length === 0
                              ? 'Medie generală:'
                              : 'Medie curentă:'}{' '}
                            <br />
                            {calculare_medii(
                              gradesElevi?.[e.id]?.note || [],
                              materii,
                              scutiri[e.id],
                              e
                            )}
                          </p>

                          {e?.retreas !== true && (
                            <Popup
                              content={
                                <div>
                                  {materiiCuMediaDeschisa?.length > 0 ? (
                                    <>
                                      Materii cu media deschisă:
                                      <br />
                                      {materiiCuMediaDeschisa.map(
                                        (m, index) => {
                                          const nume = materii?.find(
                                            (ma) => ma.id === m.materie
                                          )?.numeMaterie;

                                          // Nu afișa materiile de religie în funcție de tipul ales
                                          if (
                                            nume === 'Religie' &&
                                            (e?.religie === 'penticostala' ||
                                              e?.religie === 'nu')
                                          ) {
                                            return null;
                                          }
                                          if (
                                            (nume === 'Religie Penticostală' ||
                                              m?.materie?.includes('RP')) &&
                                            e?.religie !== 'penticostala'
                                          ) {
                                            return null;
                                          }

                                          return nume ? (
                                            <span key={index}>{nume}; </span>
                                          ) : null;
                                        }
                                      )}
                                    </>
                                  ) : (
                                    'Medie încheiată'
                                  )}
                                </div>
                              }
                              on='click'
                              trigger={
                                <BS
                                  content={
                                    materiiCuMediaDeschisa?.length > 0
                                      ? 'Materii deschise'
                                      : 'Situație încheiată'
                                  }
                                  style={{
                                    fontSize: '10px',
                                    color:
                                      materiiCuMediaDeschisa?.length > 0
                                        ? 'red'
                                        : 'purple',
                                  }}
                                />
                              }
                            />
                          )}
                        </p>
                        {true === true ? (
                          <p style={{ textAlign: 'center' }}>
                            Absențe
                            <br />{' '}
                            <p style={{ padding: 0, margin: 0 }}>
                              Total:
                              {
                                gradesElevi?.[e.id]?.absente
                                  ?.absente_dupa_motivari?.length
                              }
                            </p>
                            <p
                              style={{ color: 'green', padding: 0, margin: 0 }}
                            >
                              Motivate:
                              {
                                gradesElevi?.[e.id]?.absente?.absente_motivate
                                  .length
                              }
                            </p>
                            <p style={{ color: 'red', padding: 0, margin: 0 }}>
                              Nemotivate:
                              {
                                gradesElevi?.[e.id]?.absente.absente_nemotivate
                                  .length
                              }
                            </p>
                          </p>
                        ) : (
                          <p
                            style={{
                              color: 'red',
                              textAlign: 'center',
                            }}
                          >
                            Abs
                            <br />{' '}
                            {
                              gradesElevi?.[e.id]?.absente.absente_nemotivate
                                .length
                            }
                          </p>
                        )}
                      </CatalogTabel.Cell>
                    )}
                  </CatalogTabel.Row>
                );
              })}
          </CatalogTabel.Body>
        </CatalogTabel>
      </div>

      {window.screen.width > 750 &&
        (user.type === 'admin' || user.id === classData?.diriginte) && (
          <Button
            onClick={() => {
              setDisplay(true);
              //handlePrint();
            }}
            type='primary'
            danger
          >
            Printează
          </Button>
        )}
      <Button
        onClick={() => {
          setSumar(true);
        }}
      >
        Genereaza Sumar clasa
      </Button>

      {sumar === true && (
        <>
          <div style={{ display: 'none' }}>
            <div ref={auditRef2} className='print'>
              {' '}
              <div style={{ pageBreakAfter: 'always' }}>
                <br /> <br />
                <br />
                <br />
                <br />
                <h1 style={{ textAlign: 'center' }}>
                  Catalogul clasei{' '}
                  {classData?.anClasa + ' ' + classData?.identificator}
                </h1>
                <h4 style={{ textAlign: 'center' }}>
                  Instituție școlară: {settings?.numeInstitutie}
                  <br />
                  Anul școlar 2024-2025
                  <br />
                  Diriginte/Învățător:{' '}
                  {profesori?.find((p) => p.id === classData?.diriginte)
                    ?.numeDeFamilie +
                    ' ' +
                    profesori?.find((p) => p.id === classData?.diriginte)
                      ?.prenume}
                  <br />
                </h4>
                <h5 style={{ paddingLeft: '50px' }}>
                  Materii înscrise în catalog
                </h5>
                <table border='1' style={{ width: '90%', marginLeft: '5%' }}>
                  {window.innerWidth > 768 && (
                    <thead>
                      <tr>
                        <th>Materie</th>
                        <th>Profesori</th>
                      </tr>
                    </thead>
                  )}
                  <tbody>
                    {classData?.materii.map((m) => {
                      return (
                        <tr
                          style={{
                            pageBreakInside: 'avoid',
                            pageBreakAfter: 'auto',
                          }}
                        >
                          <td>
                            <p style={{ paddingLeft: '10px' }}>
                              {
                                materii?.find((ma) => ma.id === m.materie)
                                  ?.numeMaterie
                              }
                            </p>
                          </td>
                          <td>
                            <div
                              style={{
                                display: 'grid',
                                gridTemplateColumns: 'auto auto  ',
                                paddingLeft: '10px',
                                pageBreakInside: 'avoid',
                                pageBreakAfter: 'auto',
                              }}
                            >
                              {m?.profesori?.map((idp) => (
                                <p>
                                  {profesori?.find((p) => p.id === idp)
                                    ?.numeDeFamilie +
                                    ' ' +
                                    profesori?.find((p) => p.id === idp)
                                      ?.prenume}
                                </p>
                              ))}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <br />
                <br />
              </div>
              {eleviData
                .sort((a, b) => a?.nume?.localeCompare(b.nume, 'ro'))
                .map((c) => {
                  return (
                    <div style={{ pageBreakBefore: 'always' }}>
                      <h1
                        style={{ paddingTop: '30px', textAlign: 'center' }}
                        className='sentry-mask'
                      >
                        {c.numeDeFamilie + ' ' + c.initiala + ' ' + c.prenume}
                      </h1>
                      <h2>{profileElevi?.[c.id]?.cnp}</h2>
                      <div style={{ padding: '20px' }}>
                        <CatalogElev
                          elevIdPassed={c.id || c.idElev}
                          materiiLimited={
                            activeMaterii?.length === 0 ? [] : activeMaterii
                          }
                        />
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
          <Button
            onClick={() => {
              handlePrint2();
            }}
          >
            Printeza Export Sumar
          </Button>
        </>
      )}
      <br />
      <br />

      {display === true && (
        <CatalogPrint classData={classData} mode='edit' permision={permision} />
      )}

      {/* {window.screen.width > 750 && (
            <Button
              onClick={async () => {
                await exportExcel(
                  eleviData
                    .sort((a, b) => {
                      return a?.nume?.localeCompare(b.nume, "ro");
                    })
                    .map((e, index) => {
                      // let nrNemotivate = (gradesElevi?.[e.id]?.note || []).filter(
                      //   (n) => {
                      //     let motivat = false;
                      //     if (n.tip !== "absenta") return false;
                      //     let scutiriElev = scutiri[e.id];

                      //     if (
                      //       (scutiriElev || [])?.find(
                      //         (scut) =>
                      //           new Date(scut.interval[0]) <=
                      //             new Date(n?.date) &&
                      //           new Date(scut.interval[1]) >= new Date(n?.date)
                      //       )
                      //     )
                      //       motivat = true;

                      //     return motivat === false && n.tip === "absenta";
                      //   }
                      // ).length;
                      // let nrMotivate = (gradesElevi?.[e.id]?.note || []).filter(
                      //   (n) => {
                      //     let motivat = false;
                      //     if (n.tip !== "absenta") return false;
                      //     let scutiriElev = scutiri[e.id];

                      //     if (
                      //       (scutiriElev || [])?.find(
                      //         (scut) =>
                      //           new Date(scut.interval[0]) <=
                      //             new Date(n?.date) &&
                      //           new Date(scut.interval[1]) >= new Date(n?.date)
                      //       )
                      //     )
                      //       motivat = true;

                      //     return motivat === true && n.tip === "absenta";
                      //   }
                      // ).length;
                      // let nrtotal = (gradesElevi?.[e.id]?.note || []).filter(
                      //   (n) => {
                      //     let motivat = false;
                      //     if (n.tip !== "absenta") return false;
                      //     let scutiriElev = scutiri[e.id];

                      //     if (
                      //       (scutiriElev || [])?.find(
                      //         (scut) =>
                      //           new Date(scut.interval[0]) <=
                      //             new Date(n?.date) &&
                      //           new Date(scut.interval[1]) >= new Date(n?.date)
                      //       )
                      //     )
                      //       motivat = true;

                      //     return n.tip === "absenta";
                      //   }
                      // ).length;
                      return {
                        Nume: e.nume,
                        ...classData?.materii
                          .sort((a, b) => {
                            if (
                              pref.findIndex(
                                (x) =>
                                  x ===
                                  materii?.find((m) => m.id === a.materie)?.numeMaterie
                              ) === -1
                            )
                              return 1;
                            if (
                              pref.findIndex(
                                (x) =>
                                  x ===
                                  materii?.find((m) => m.id === a.materie)?.numeMaterie
                              ) <
                              pref.findIndex(
                                (x) =>
                                  x ===
                                  materii?.find((m) => m.id === b.materie)?.numeMaterie
                              )
                            )
                              return -1;
                            return 1;
                          })
                          .reduce((obj, m) => {
                            let inchis = (gradesElevi?.[e.id]?.note || [])?.find(
                              (n) =>
                                n.materieId === m.materie &&
                                n.tip === "inchidere_medie"
                            );
                            const materie = materii?.find(
                              (ma) => ma.id === m.materie
                            );
                            const calificative = {
                              FB: 1,
                              B: 2,
                              S: 3,
                              I: 4,
                            };
                            let freq = {};
                            let notaFinala = 0,
                              frv = 0;
                            if (materie?.notare === false) {
                              for (const num of (
                                gradesElevi?.[e.id]?.note || []
                              ).filter(
                                (n) =>
                                  n.materieId === m.materie && n.tip === "nota"
                              )) {
                                freq[calificative[num.nota]] = freq[
                                  calificative[num.nota]
                                ]
                                  ? freq[calificative[num.nota]] + 1
                                  : 1;
                              }

                              if (frv < freq[1]) {
                                frv = freq[1];
                                notaFinala = "FB";
                              }
                              if (frv < freq[2]) {
                                frv = freq[2];
                                notaFinala = "B";
                              }
                              if (frv < freq[3]) {
                                frv = freq[3];
                                notaFinala = "S";
                              }
                              if (frv < freq[4]) {
                                frv = freq[4];
                                notaFinala = "I";
                              }
                            }

                            let sum = (gradesElevi?.[e.id]?.note || [])
                              .filter(
                                (n) =>
                                  n.materieId === m.materie && n.tip === "nota"
                              )
                              .reduce((acc, curent) => {
                                return acc + curent.nota;
                              }, 0);
                            let medieFinala = 0;
                            if (
                              (gradesElevi?.[e.id]?.note || [])?.find(
                                (n) =>
                                  n.materieId === m.materie &&
                                  n.tip === "examen_final"
                              ) === undefined
                            ) {
                              medieFinala = Math.round(
                                sum /
                                  ((gradesElevi?.[e.id]?.note || []).filter(
                                    (n) =>
                                      n.materieId === m.materie &&
                                      n.tip === "nota"
                                  )?.length || 1)
                              );
                            } else if (
                              (gradesElevi?.[e.id]?.note || [])?.find(
                                (n) =>
                                  n.materieId === m.materie &&
                                  n.tip === "examen_final"
                              )
                            ) {
                              let ef = (gradesElevi?.[e.id]?.note || [])?.find(
                                (n) =>
                                  n.materieId === m.materie &&
                                  n.tip === "examen_final"
                              ).examen_final;

                              medieFinala =
                                sum /
                                ((gradesElevi?.[e.id]?.note || []).filter(
                                  (n) =>
                                    n.materieId === m.materie &&
                                    n.tip === "nota"
                                )?.length || 1);

                              let rawNumber =
                                (parseFloat(medieFinala) + parseFloat(ef)) / 2;
                              let roundedNumber =
                                Math.round(rawNumber * 1000) / 1000; // Pas intermediar pentru a influența rotunjirea

                              roundedNumber =
                                Math.round(
                                  Math.round(roundedNumber * 1000) / 10
                                ) / 100; // Rotunjire la două zecimale cu influența zecimalei a treia

                              medieFinala = roundedNumber;
                            }
                            let corigenta = (
                              gradesElevi?.[e.id]?.note || []
                            )?.find(
                              (n) =>
                                n.materieId === m.materie &&
                                n.tip === "corigenta"
                            );

                            let newObject = {};
                            if (
                              (gradesElevi?.[e.id]?.note || []).filter(
                                (n) =>
                                  n.materieId === m.materie && n.tip === "nota"
                              )?.length === 0 &&
                              !materii
                                .find((n) => n.id === m.materie)?.numeMaterie.includes("Purtare")
                            )
                              newObject[
                                materii?.find(
                                  (ma) => ma.id === m.materie
                                )?.numeMaterie
                              ] = "-";
                            else
                              newObject[
                                materii?.find(
                                  (ma) => ma.id === m.materie
                                )?.numeMaterie
                              ] =
                                corigenta ??
                                materii?.find((ma) => ma.id === m.materie)
                                  ?.notare === false
                                  ? inchis?.inchidere_medie || notaFinala
                                  : inchis?.inchidere_medie || medieFinala;
                            return { ...obj, ...newObject };
                          }, {}),

                        "Medie Generala": calculare_medii(
                          gradesElevi?.[e.id]?.note || [],
                          
                          materii,
                          scutiri[e.id]
                        ),
                      };
                    }),
                  classData.anClasa +
                    classData.identificator +
                    " - " +
                    "Statistica Materii"
                );
              }}
              type="primary"
            >
              Excel Materii + Medie
            </Button>
          )} */}

      {permision === true && (
        <>
          <Button type='primary' onClick={exportToExcel}>
            Exportă în Excel
          </Button>
          <ExportMedii
            classData={classData}
            eleviData={eleviData}
            gradesElevi={gradesElevi}
            scutiri={scutiri}
            permision={permision}
          />
        </>
      )}

      <AddElev
        open={addElev}
        setConfirmLoading={setConfirmLoading}
        confirmLoading={confirmLoading}
        setOpen={setAddElev}
        clasaDefault={classData?.id}
      />
    </div>
  );
}

export default withErrorBoundary(Catalog);
